

export function collectSearchKeys(name, email, role) {
  /** @type {Set<string>} */
  const keys = new Set()
  const add = (value) => {
    const v = String(value ?? '').trim().toLowerCase()
    if (v) keys.add(v)
  }

  add(name)
  add(email)
  add(role)

  const words = String(name ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (words.length > 0) {
    add(words.map((w) => w[0]).join(''))
    if (words.length >= 2) {
      add(`${words[0][0]}${words[words.length - 1][0]}`)
    }
    words.forEach((w) => add(w))
  }

  const local = String(email ?? '').split('@')[0] ?? ''
  if (local) {
    add(local)
    const alpha = local.replace(/[^a-z0-9]/gi, '')
    if (alpha.length >= 2) add(alpha.slice(0, 2))
    if (alpha.length >= 1) add(alpha[0])
  }

  return keys
}
